<!-- 医疗案例 -->
<template>
  <div class="case">
    <h4 class="current">
      您的位置：<router-link to="/home">首页 </router-link> &gt;产品与方案 &gt; 医院绩效管理解决方案
    </h4>
    <div class="article">
      <h5>医院绩效管理解决方案</h5>
      <!-- <h4 class="smalltit">绩效改革的背景和必要性</h4>
      <p>
        <span class="boldblack">内外部环境</span> <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;随着医改进程加快，医保支付政策持续调整，医院内部激励方向急需转到以劳动价值为核心、统筹效率与公平、确保医院发展需要上来。国务院办公厅印发的《关于城市公立医院综合改革试点的指导意见》，国家卫生计生委、人力资源社会保障部、财政部、国家中医药管理局《关于加强公立医疗卫生机构绩效评价的指导意见》进一步明确和细化绩效评价内容，国办发〔2016〕26号明确要求公立医院要建立以公益性为导向的考核评价机制。在内部薪酬体系上，明确“公立医院通过科学的绩效考核自主进行收入分配，做到多劳多得、优绩优酬”。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;国家新医改发展至今，医院快速扩张的发展方式已经不复存在。特别是医保基金的收紧，导致医院可能出现干得多亏的多，倒逼医院必须向精细化管理转型，精耕细作，开源、节流调结构，才能取得长远的发展。所以实现精细化的管理，是当前所有公立医院管理面临的核心问题。绩效管理是助力医院实现精细化管理，实现医院战略发展的最重要工具。
        <br />

        <span class="boldblack">当下医院发展面临的困惑及问题</span>
      </p> -->
      <img src="@/assets/conimg001.png" />
      <img src="@/assets/conimg002.png" />
      <img src="@/assets/conimg003.png" />
      <img src="@/assets/conimg004.png" />
      <img src="@/assets/conimg005.png" />
      <img src="@/assets/conimg006.png" />
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
h4.current {
  display: block;
  height: 40px;
  line-height: 30px;
  background: url(../../../assets/currentbg.jpg) repeat-x bottom;
  color: #333;
}
h4.current a:hover {
  color: #e90000;
}
.article h5 {
  display: block;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  color: #333;
  margin-top: 40px;
}
.article h6 {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #888;
  margin-top: 5px;
  margin-bottom: 30px;
}
.smalltit {
  display: block;
  height: 55px;
  line-height: 55px;
  margin-top: 20px;
  padding-left: 35px;
  background: url(../../../assets/ico01.png) no-repeat left center;
  font-size: 22px;
  color: #e60212;
}
.intro p {
  line-height: 30px;
}
.intro img {
  display: block;
  margin: 0 auto;
}
.article img {
  //margin: 0 auto;
  display: block;
  margin-top: 15px;
}
.article p {
  margin-top: 15px;
  line-height: 30px;
  margin: 15px 0;
}
.boldblack {
  color: #333;
  font-weight: bold;
}
.boldred {
  color: #f00;
  font-weight: bold;
}
.font18 {
  font-size: 18px;
}
</style>
